var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.66797H6.66683M13.3335 6.66797C15.1744 6.66797 16.6668 8.16035 16.6668 10.0013V15.0013C16.6668 16.8423 15.1744 18.3346 13.3335 18.3346H6.66683C4.82588 18.3346 3.3335 16.8423 3.3335 15.0013V10.0013C3.3335 8.16035 4.82588 6.66797 6.66683 6.66797M13.3335 6.66797V5.0013C13.3335 3.16035 11.8411 1.66797 10.0002 1.66797C8.15922 1.66797 6.66683 3.16035 6.66683 5.0013V6.66797M11.6668 12.5013C11.6668 13.4218 10.9206 14.168 10.0002 14.168C9.07969 14.168 8.3335 13.4218 8.3335 12.5013C8.3335 11.5808 9.07969 10.8346 10.0002 10.8346C10.9206 10.8346 11.6668 11.5808 11.6668 12.5013Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock_white.f6718e268014e7fe01f5deeaa59ac369.svg";